/**
 * Auth circuit breaker state.
 *
 * Prevents cascading errors when a session expires: once the circuit opens,
 * all TanStack Query retries are suppressed until the user re-authenticates.
 *
 * Extracted to its own module to avoid circular imports between App.tsx
 * and auth-context.tsx.
 */

let circuitOpen = false;

/** Open the circuit breaker. Called on first auth error detection. */
export function openAuthCircuit(): void {
  circuitOpen = true;
}

/** Close the circuit breaker. Called when a fresh session is established (SIGNED_IN). */
export function resetAuthCircuit(): void {
  circuitOpen = false;
}

/** Check whether the circuit breaker is currently open. */
export function isAuthCircuitOpen(): boolean {
  return circuitOpen;
}
